
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/directory/listings/[page]",
      function () {
        return require("private-next-pages/directory/listings/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/directory/listings/[page]"])
      });
    }
  